import { useLocation } from 'react-router-dom';
import { useAppMode } from '../Providers/AppModeProvider';

const AUTH_SCREEN_PATHS = ['/', '/signup'];
// Payment/signup-return render their own full-page chrome (Stripe iframe, checkout-status
// panel) the same way AuthLayout's screens do. Hiding Header/Footer here also stops Header's
// background calls (customer details, notifications) from 402ing while a company is still
// pending checkout (ROAR-4878 — see the response interceptor in src/api/queries/auth.js).
// /auth/callback joins this list for the same reason (ROAR-4900) — browser Back from the Stripe
// payment screen re-lands here (a hard window.location navigation, not a router push) with an
// already-consumed one-time code, showing its own standalone error card; without this, the full
// logged-in Header (nav buttons included) rendered on top of that error state.
// Unlike AUTH_SCREEN_PATHS, these hide chrome in every APP_MODE — genptbeta's carve-out is
// specific to "/" being a different marketing funnel, which doesn't apply to any of these.
// /mcp/authorize (ROAR-4988) is the headless MCP handoff — a spinner or a standalone error card.
// Listed with and without a trailing slash, the same two forms isMcpAuthorizePath accepts for
// logout()/the 402 interceptor (kept literal so this hook has no dependency on authActions).
const CHROMELESS_SCREEN_PATHS = ['/payment', '/signup/return', '/auth/callback', '/mcp/authorize', '/mcp/authorize/'];

/**
 * True on screens that render their own full-page chrome and hide the app's top Header / bottom
 * Footer: the login (`/`) and signup (`/signup`) screens outside genptbeta mode (ROAR-4795/4750
 * UI alignment — genptbeta's "/" is a different, untouched marketing funnel that still relies on
 * the app chrome, so it's excluded there), plus /payment and /signup/return (ROAR-4878) in every
 * mode.
 */
const useIsAuthScreen = () => {
  const { pathname } = useLocation();
  // Optional chaining: tolerates rendering outside AppModeProvider (e.g. component tests that
  // don't need the rest of its context) by treating an absent APP_MODE as "not genptbeta".
  const appMode = useAppMode()?.APP_MODE;
  const isLoginOrSignup = appMode !== 'genptbeta' && AUTH_SCREEN_PATHS.includes(pathname);
  return isLoginOrSignup || CHROMELESS_SCREEN_PATHS.includes(pathname);
};

export default useIsAuthScreen;
